import type { FaireProductEntity } from "../../entity_types/product";

export const p_t735dkivfd: FaireProductEntity = {
  token: "p_t735dkivfd",
  type: "product",
  name: "30ct/4oz Popcorn Sampler ",
  brandName: "Amish Country Popcorn",
  imageUrl:
    "https://cdn.faire.com/fastly/e20fd1d0bc49435e74fa20f3a67ccd86b5f383ce46800bb10ef7415b6f032491.png",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2225c92800fb623ae6495c4c076d66b224181c45cb0704cea6a6ce778a75634d.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
